import * as React from "react";
import Rest from "src/services/Rest";
import './ProductCortez.scss';

import { Header, Navigation, Footer } from "../../shared";

import { ProductTableCortez } from "./ProductTableCortez";
import ExportInProgress from "src/component/export-in-progress/ExportInProgress";

import {
	AppBar,
	Button,
	CardActions,
	CardContent,
	FormGroup,
	IconButton,
	Grid, 
	Paper, 
	Snackbar,
	SnackbarContent,
	Tab,
	Tabs, 
	TextField,
	Tooltip
} from "@material-ui/core";

import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import GetAppIcon from "@material-ui/icons/GetApp";

const styles = {
	dateField: {
		marginLeft: 5,
		marginRight: 5,
		minWidth: "40%",
	},
  	textField: {
		marginLeft: 5,
		marginRight: 5,
	},
};

function LinkTab(props: any) {
    return (
        // tslint:disable-next-line:jsx-no-lambda
        <Tab component="a" onClick={event => event.preventDefault()} {...props} />
    );
}

// tslint:disable-next-line:no-empty-interface
export interface IProductCortezProps {}

// tslint:disable-next-line:no-empty-interface
export interface IProductCortezState {
	alertMessage: string;
	alertOpened: boolean;
	alertType: string;

	error: string | null;
	filters: {
		autor: string;
		bisac: string;
		categoria: string;
		expirationEndDate: any;
		expirationInitialDate: any;
		page: number;
		publicationEndDate: any;
		publicationInitialDate: any;
		selo: string;
		size: number;
		sku: string;
		tab: number;
		titulo: string;
	};
	loading: boolean;
	modalImage: {
		img: string;
		open: boolean;
	}
	processando: boolean;
	produto: {};
	rows?: any[];
	totalItems: number;
}

export class ProductCortez extends React.Component<
	IProductCortezProps,
	IProductCortezState
> {

	constructor(props: IProductCortezProps) {
		super(props);

		this.state = {
			alertMessage: "",
			alertOpened: false,
			alertType: "success",

			error: null,
			filters: {
				autor: "",
				bisac: "",
				categoria: "",
				expirationEndDate: undefined,
				expirationInitialDate: undefined,
				page: 0,
				publicationEndDate: undefined,
				publicationInitialDate: undefined,
				selo: "",
				size: 10,
				sku: "",
				tab: 1,
				titulo: "",
			},
			loading: false,
			modalImage: {
				img: '',
				open: false,
			},
			processando: false,
			produto: {},
			rows: [],
			totalItems: 0,
    	};

		this.changeDate = this.changeDate.bind(this);
		this.clear = this.clear.bind(this);
		this.search = this.search.bind(this);
	}

	public componentDidMount() {
		this.search();
	}

	public render() {
		const { filters } = this.state;
		const { page, size } = filters;
		return (
			<div>
				<Header
					title={"Lista Cortez"}
					name={"Lista Cortez"}
					link={"/dashboard"}
				/>
				<Navigation
					name={"Listagem de Produtos Cortez"}
					linkDefault={"/cortez/product-cortez"}
					link={"/dashboard"}
					linkTitle={"Produtos"}
					painel={3}
					icon={<ChevronRightIcon />}
				/>
				<div className="wrapper">
					<Grid
						container={true}
						className="panel-grid"
						spacing={16}
					>
						<Grid item={true} xs={12} >
							<AppBar position="static" style={{ backgroundColor: '#FFFF' }}>
                                <Tabs fullWidth={true} value={this.state.filters.tab} onChange={this.handleChangeTab} centered={true} 
                                    textColor="primary" indicatorColor="primary">
            
                                    <LinkTab label="6 Meses" href="6 Meses" value={1} />
									<LinkTab label="12 Meses" href="12 Meses" value={2} />
                                </Tabs>
                            </AppBar>
							<Paper className="analytical-panel">
								<Snackbar
									anchorOrigin={{
										horizontal: "center",
										vertical: "center",
									}}
									open={this.state.alertOpened}
									autoHideDuration={4000}
									onClose={this.closeAlert}
								>
									<SnackbarContent
										message={this.state.alertMessage}
										style={styles[this.state.alertType]}
									/>
								</Snackbar>
								<Grid container={true}>
									<Grid className="analytical-header" item={true} xs={12}>
                                        <form> 
											<FormGroup className="date-bar" row={true}>
												<div className="date-wrapper">
													<TextField
														defaultValue={this.state.filters.publicationInitialDate}
														value={this.state.filters.publicationInitialDate}
														id="publicationInitialDate"
														label="Data inicial de publicação"
														type="date"
														// required={true}
														style={this.dateFieldStyle()}
														onChange={(ev) => this.handleFilter(ev, "publicationInitialDate")}
														InputLabelProps={{
															shrink: true,
														}}
													/>
													<TextField
														defaultValue={this.state.filters.publicationEndDate}
														value={this.state.filters.publicationEndDate}
														id="publicationEndDate"
														label="Data final de publicação"
														type="date"
														// required={true}
														style={this.dateFieldStyle()}
														onChange={(ev) => this.handleFilter(ev, "publicationEndDate")}
														InputLabelProps={{
															shrink: true,
														}}
													/>
												</div>
												<div>
													<TextField
														defaultValue={this.state.filters.expirationInitialDate}
														value={this.state.filters.expirationInitialDate}
														id="expirationInitialDate"
														label="Data inicial de vencimento"
														type="date"
														// required={true}
														style={this.dateFieldStyle()}
														onChange={(ev) => this.handleFilter(ev, "expirationInitialDate")}
														InputLabelProps={{
															shrink: true,
														}}
													/>
													<TextField
														defaultValue={this.state.filters.expirationEndDate}
														value={this.state.filters.expirationEndDate}
														id="expirationEndDate"
														label="Data final de vencimento"
														type="date"
														// required={true}
														style={this.dateFieldStyle()}
														onChange={(ev) => this.handleFilter(ev, "expirationEndDate")}
														InputLabelProps={{
															shrink: true,
														}}
													/>
												</div>
											</FormGroup>
											<FormGroup className="search-bar" row={true}>
												<TextField
													label="SKU"
													value={this.state.filters.sku}
													onChange={this.handleChangeCadastro("sku")}
													style={this.textFieldStyle()}
													type="text"
													autoComplete="text"
													margin="normal"
												/>
												<TextField
													label="Titulo"
													value={this.state.filters.titulo}
													onChange={this.handleChangeCadastro("titulo")}
													style={this.textFieldStyle()}
													type="text"
													autoComplete="text"
													margin="normal"
												/>
												<TextField
													label="Autor"
													value={this.state.filters.autor}
													onChange={this.handleChangeCadastro("autor")}
													style={this.textFieldStyle()}
													type="text"
													autoComplete="text"
													margin="normal"
												/>
											</FormGroup>
											<FormGroup className="search-bar" row={true}>
												<TextField
													label="Bisac"
													value={this.state.filters.bisac}
													onChange={this.handleChangeCadastro("bisac")}
													style={this.textFieldStyle()}
													type="text"
													autoComplete="text"
													margin="normal"
												/>
												<TextField
													label="Categoria"
													value={this.state.filters.categoria}
													onChange={this.handleChangeCadastro("categoria")}
													style={this.textFieldStyle()}
													type="text"
													autoComplete="text"
													margin="normal"
												/>
												<TextField
													label="Selo"
													value={this.state.filters.selo}
													onChange={this.handleChangeCadastro("selo")}
													style={this.textFieldStyle()}
													type="text"
													autoComplete="text"
													margin="normal"
												/>
											</FormGroup>
										</form>
										<CardActions className="actions-bar">
											<div>
												<Button
													className="filter-dialog-clear"
													onClick={this.clear}
												>
													Limpar
												</Button>
												<Button
													className="filter-dialog-close"
													color="primary"
													onClick={this.search}
												>
													Pesquisar
												</Button>
											</div>
											<div>
												{!this.state.processando && (
													<IconButton
														color="primary"
														className="download-button"
														onClick={() => this.requestExport()}
													>
														<Tooltip title="Exportar">
															<GetAppIcon />
														</Tooltip>
													</IconButton>
												)}
												<ExportInProgress
													tipos={["CORTEZ_PRODUCTS_LIST"]}
													visible={this.state.processando}
													handleState={(valor:any) =>
														this.setState({ processando: valor })
													}
												/>
											</div>
										</CardActions>
                                    </Grid>
									<Grid item={true} xs={12}>
										<CardContent>
											<ProductTableCortez
												error={this.state.error}
												loading={this.state.loading}
												items={[
													{ header: "Capa", row: "imagem" },
													{ header: "SKU", row: "sku" },
													{ header: "Título", row: "titulo" },
													// { header: "Fabricante", row: "fabricante" },
													{ header: "Selo", row: "selo" },
													{ header: "Grupo Econômico", row: "grupo_economico" },
													{ header: "Autor", row: "autor" },
													{ header: "Bisac", row: "bisac" },
													{ header: "Categoria", row: "categoria" },
													{ header: "Preço Capa", row: "preco_capa" },
													{ header: "Data Publicação", row: "dta_publicacao" },
													{ header: "Data Vencimento", row: "dta_vencimento" },
												]}
												rows={this.state.rows}
												modalImage={this.state.modalImage}
												handleChangePage={this.handleChangePage}
												handleChangeRowsPerPage={this.handleChangeRowsPerPage}
												handleModalImage={this.handleModalImage}
												tableProps={{
													limit: size,
													page,
													total: this.state.totalItems,
												}}
											/>
										</CardContent>
									</Grid>
								</Grid>
							</Paper>
						</Grid>
					</Grid>
				</div>
				<div className="users-register-footer">
					<Footer />
				</div>
			</div>
    	);
	}

	public changeDate (init: any, end: any) {
		const filter = this.state.filters;
		filter.publicationInitialDate = init;
		filter.publicationEndDate = end;
		this.setFilters(filter);
    }

	private openAlert = (msg: string, tipo: string) => {
		this.setState({ alertMessage: msg, alertType: tipo, alertOpened: true });
	};
	
	private closeAlert = () => {
		this.setState({ alertMessage: "", alertType: "", alertOpened: false });
	};

	private async requestExport() {
		const endPoint = `cortez/product/export`;
		const response = await Rest.PostBody(endPoint, this.state.filters);
		if (response) {
			this.openAlert('O relatório está sendo preparado para download', 'sucess');
			this.setState({ processando: true });
		}
	};
	
	private search() {
		const { page, size } = this.state.filters;
		this.setState({ loading: true });
		let endPoint = "cortez/product";
		let queryParam = `?page=${page}&size=${size}&tab=${this.state.filters.tab}`;
	
		queryParam += this.getParams(this.state.filters);
	
		endPoint += queryParam;
	
		Rest.GET(endPoint, null)
			.then((response) => response.json())
			.then((result:any) => {
				if (!!result) {
					if(result.error) {
						this.setState({ loading: false, rows: [], totalItems: 0 });
						return
					}
					this.setState({
						loading: false,
						rows: result.products,
						totalItems: Number(result.rowCount)
					})
				}
			})
	}

	private async handleFilter(ev: any, chave: string) {
		const params = Object.assign({}, this.state.filters);
		params[chave] = ev.target.value;
		await this.setFilters(params);
	}

	private setFilters = async (filters: {
		autor: string;
		bisac: string;
		categoria: string;
		expirationEndDate: any;
		expirationInitialDate: any;
		// fabricante: string;
		page: number;
		publicationEndDate: any;
		publicationInitialDate: any;
		selo: string;
		size: number;
		sku: string;
		tab: number;
		titulo: string;
	}) => {
		this.setState({ filters });
	};
	
	private async clear() {
		await this.setFilters({
			autor: "",
			bisac: "",
			categoria: "",
			expirationEndDate: "",
			expirationInitialDate: "",
			// fabricante: "",
			page: 0,
			publicationEndDate: "",
			publicationInitialDate: "",
			selo: "",
			size: 10,
			sku: "",
			tab: this.state.filters.tab,
			titulo: "",
		});
		this.search();
	}

	private handleChangePage = async (ev: any, page: number) => {
		const filters = this.state.filters;
		filters.page = page;
		await this.setFilters(filters);
		this.search();
	};

	private handleChangeRowsPerPage = async(event: React.ChangeEvent<HTMLInputElement>) => {
        const newLimit = parseInt(event.target.value, 10);
        const filters = this.state.filters;
		filters.size = newLimit;
		await this.setFilters(filters);
		this.search();
    }

	private handleChangeCadastro = (param: string) => async (event: any) => {
		const filters = this.state.filters;
		filters[param] = param.includes("size")
			? event.target.value
			: event.currentTarget.value;
		await this.setFilters(filters);
	};

	private handleChangeTab = (event: any, value: number) => {
        this.setState({
            filters: Object.assign(this.state.filters, { tab: value })
        });
		this.clear();
    };

	private handleModalImage = (img: any) => {
        this.setState({ modalImage: { img, open: !this.state.modalImage.open } })
		console.log(this.state.modalImage);
    }

	private textFieldStyle = () => {
		return Object.assign({}, styles.textField);
	};

	private dateFieldStyle = () => {
		return Object.assign({}, styles.dateField);
	};
	
	private getParams = (filter: any) => {
		let queryParam = "";
		if (!!filter.sku) {
			queryParam += `&sku=${filter.sku}`;
		}
		
		if (!!filter.titulo) {
			queryParam += `&titulo=${filter.titulo}`;
		}

		if (!!filter.autor) {
			queryParam += `&autor=${filter.autor}`;
		}
		
		if (!!filter.selo) {
			queryParam += `&selo=${filter.selo}`;
		}
		
		if (!!filter.bisac) {
			queryParam += `&bisac=${filter.bisac}`;
		}

		if (!!filter.categoria) {
			queryParam += `&categoria=${filter.categoria}`;
		}

		if (!!filter.publicationInitialDate && !!filter.publicationEndDate) {
			queryParam += `&publicationInitialDate=${filter.publicationInitialDate}`;
			queryParam += `&publicationEndDate=${filter.publicationEndDate}`;
		}

		if (!!filter.expirationInitialDate && !!filter.expirationEndDate) {
			queryParam += `&expirationInitialDate=${filter.expirationInitialDate}`;
			queryParam += `&expirationEndDate=${filter.expirationEndDate}`;
		}
		return queryParam;
	};
}



// WEBPACK FOOTER //
// ./src/component/cortez/product-cortez/ProductCortez.tsx